export const updateDriver = (data) => {
    return{
        type:'UPDATE_DRIVER',
        payload: data
    }
}

export const initializeDriver = (data) => {
    return{
        type:'INITIAILIZE_DRIVER',
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/Driver/actions.js